import React from 'react';
import { Card } from '../../components/ui/card';
import { BarChart3 } from 'lucide-react';

const CryptoHeatmap = () => {
  return (
    <div className="space-y-8 animate-fadeIn">
      <div>
        <h1 className="text-4xl font-bold text-black mb-2">Crypto Heatmap</h1>
        <p className="text-gray-600">Visual representation of cryptocurrency market performance</p>
      </div>

      <Card className="p-6">
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <BarChart3 className="w-16 h-16 text-gray-600 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Heatmap visualization coming soon</p>
            <p className="text-gray-600 text-sm mt-2">Interactive crypto market heatmap</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CryptoHeatmap;